import React from "react";
import styles from "./topDonorCard.module.scss";
import TopDonorCardPlace from "../topDonorCardPlace/topDonorCardPlace";
import TopDonorCardUser from "../topDonorCardUser/topDonorCardUser";
import { TUserData } from "../../../../stores/EventStore";
import TopDonorDonations from "../topDonorDonations/topDonorDonations";
import UserDonorClass from "../../userDonorClass";

export type TTopDonorCard = {
  user: TUserData;
  place: number;
  isMe: boolean;
};

const TopDonorCard: React.FC<TTopDonorCard> = ({ user, place, isMe }) => {
  return (
    <div className={styles.TopDonorCard} data-isme={isMe}>
      <div className={styles.TopDonorCard_First}>
        <div className={styles.TopDonorCard_First_Place}>
          <TopDonorCardPlace value={place} />
        </div>
        <TopDonorCardUser user={user} />
      </div>
      <div className={styles.TopDonorCard_Second}>
        <div className={styles.TopDonorCard_Second_Achieves}>
          <UserDonorClass user={user} />
        </div>
        <div className={styles.TopDonorCard_Second_Donations}>
          <TopDonorDonations user={user} />
        </div>
      </div>
    </div>
  );
};

export default TopDonorCard;
